var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 654,
    height: 298,
    viewBox: "0 0 654 298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Title"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 654,
    height: 298
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Title",
    clipPath: "url(#clip-Title)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13724",
    "data-name": "Group 13724",
    transform: "translate(-582.844 667.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13722",
    "data-name": "Group 13722",
    transform: "translate(1036.253 -629.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14293",
    "data-name": "Path 14293",
    d: "M1128.075-541.517l3.563-12.227,17.945-.019,1.751,11.891,16.955-.259-13.083-79.247-19.519-1.561-26.206,81.705Zm15.513-53.527,3.278,22.5-9.74-.2Z",
    transform: "translate(-1035.573 629.456)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14294",
    "data-name": "Path 14294",
    d: "M1185.849-542.41l14.812-.226,1.744-22.521,20.357-50.819-16.057-1.277-9.537,26.27-5.568-27.479-17.689-1.415,13.672,54.523Z",
    transform: "translate(-1035.489 629.465)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14295",
    "data-name": "Path 14295",
    d: "M1096.521-489.1a45.324,45.324,0,0,0-2.168-9.759,32.444,32.444,0,0,0-4.075-8.122,25.869,25.869,0,0,0-5.872-6.016q-6.885-5.057-16.667-4.66l-27.045,1.091-5.027,87.315,26.9-3.545a34.375,34.375,0,0,0,4.762-.968,32.27,32.27,0,0,0,8.622-3.83,34.768,34.768,0,0,0,3.878-2.851,41.626,41.626,0,0,0,6.661-7.158,48.027,48.027,0,0,0,5.135-8.924,58.165,58.165,0,0,0,3.452-10.233,66.808,66.808,0,0,0,1.655-11.2A62.632,62.632,0,0,0,1096.521-489.1Zm-18.84,12.781a32.074,32.074,0,0,1-1.45,8.039,19.9,19.9,0,0,1-3.23,6.159,15.9,15.9,0,0,1-4.769,4.122,15.674,15.674,0,0,1-6.008,1.844l-4.754.505,2.294-38.144,4.756-.313q6.649-.438,10.2,4.2a14.108,14.108,0,0,1,2.5,5.691A28.887,28.887,0,0,1,1077.681-476.32Z",
    transform: "translate(-1035.668 629.738)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14296",
    "data-name": "Path 14296",
    d: "M1184.828-496.065l-5.7-26.092-17.863.723,13.951,51.464-1.69,22.544,14.957-1.971,1.7-22.135,20.426-51.9-16.226.655Z",
    transform: "translate(-1035.505 629.723)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14297",
    "data-name": "Path 14297",
    d: "M1080.594-541.129a28.329,28.329,0,0,0,4.424-1.109,27.626,27.626,0,0,0,4.133-1.789,29.167,29.167,0,0,0,3.852-2.463,35.139,35.139,0,0,0,6.621-6.552,42.887,42.887,0,0,0,5.114-8.554,54.554,54.554,0,0,0,3.454-10.093,67.53,67.53,0,0,0,1.669-11.305,67.157,67.157,0,0,0-.178-11.472,51.578,51.578,0,0,0-2.123-10.287,38.707,38.707,0,0,0-4.018-8.834,31.3,31.3,0,0,0-5.807-6.893,27.507,27.507,0,0,0-16.511-6.8l-26.833-2.155-5.207,89.138,26.685-.407A31.46,31.46,0,0,0,1080.594-541.129Zm-9.706-23.669,2.374-38.922,4.717.253a12.312,12.312,0,0,1,10.1,5.545,16.784,16.784,0,0,1,2.463,6.15,31.375,31.375,0,0,1,.432,8.17,31.966,31.966,0,0,1-1.459,8.086,17.917,17.917,0,0,1-3.219,5.939,13.333,13.333,0,0,1-4.739,3.661,13.969,13.969,0,0,1-5.967,1.17Z",
    transform: "translate(-1035.651 629.439)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14298",
    "data-name": "Path 14298",
    d: "M1122.685-519.875l-26.224,82.61,18.758-2.472,3.563-12.321,18.109-2.14,1.8,11.369,17.114-2.255-13.417-75.589Zm1.585,48.67,6.462-22.46,3.367,21.511Z",
    transform: "translate(-1035.589 629.73)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14299",
    "data-name": "Path 14299",
    d: "M1236.021-561.044l-8.654,29.9-8.629.269,5.34-30.27Z",
    transform: "translate(0.822 0.284)",
    fill: "#ffe42d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13723",
    "data-name": "Group 13723",
    transform: "translate(582.843 -667.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14300",
    "data-name": "Path 14300",
    d: "M627.948-582.181l38.22.776.306-29.722-38.358-1.636.1-18.058,52.847,2.961.378-31.353-98.6-7.888.015,134.027,44.822-.684Z",
    transform: "translate(-582.843 667.102)",
    fill: "#ffe42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14301",
    "data-name": "Path 14301",
    d: "M732.156-577.89h.167L753.329-535.7l38.08-.58L768.67-579.993a38.226,38.226,0,0,0,10.343-4.919,31.213,31.213,0,0,0,7.66-7.466,33.737,33.737,0,0,0,4.781-9.366,37.645,37.645,0,0,0,1.79-10.766,43.076,43.076,0,0,0-.9-10.22,38.233,38.233,0,0,0-3.274-9.288,33.8,33.8,0,0,0-5.732-8.122,39.658,39.658,0,0,0-8.2-6.526,44.869,44.869,0,0,0-10.677-4.651,63.2,63.2,0,0,0-12.872-2.3l-56.673-4.533-1.7,123.37,38.154-.583ZM733-623.264l14.649.8q5.094.292,7.71,3.1a10.172,10.172,0,0,1,2.515,7.469q-.1,5.148-2.753,7.46t-7.882,2.112l-14.619-.562Z",
    transform: "translate(-582.701 667.126)",
    fill: "#ffe42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14302",
    "data-name": "Path 14302",
    d: "M868.947-563.841l-34.225-.283.485-15.434,30.27.655.888-25.225-30.339-1.339.427-13.564,34.4,1.927.96-26.9-66.952-5.356-3.094,112.9L868-537.47Z",
    transform: "translate(-582.56 667.15)",
    fill: "#ffe42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14303",
    "data-name": "Path 14303",
    d: "M887.932-545.458a33.572,33.572,0,0,0,11.515,6.323,44.372,44.372,0,0,0,14.307,1.941l0,0a36.405,36.405,0,0,0,17.565-4.349,30.042,30.042,0,0,0,6.508-4.9,29.133,29.133,0,0,0,4.859-6.428,35.954,35.954,0,0,0,4.426-16.2q.394-8.644-3.046-14.473a28.942,28.942,0,0,0-8.435-9.308,105.26,105.26,0,0,0-12.917-7.376,69.189,69.189,0,0,1-10.113-5.891,6.833,6.833,0,0,1-3.05-5.922,5.96,5.96,0,0,1,1.276-3.81,3.44,3.44,0,0,1,2.9-1.222,5.567,5.567,0,0,1,4.105,2.129q1.634,1.979,1.574,6.326l28.391,1.433a46.813,46.813,0,0,0-.432-7.32,35.961,35.961,0,0,0-1.53-6.517,30.088,30.088,0,0,0-2.631-5.739,28.722,28.722,0,0,0-3.737-4.967,31.1,31.1,0,0,0-10.508-7.32,44.433,44.433,0,0,0-14.07-3.3,39.178,39.178,0,0,0-17.559,2.306,28.632,28.632,0,0,0-7.262,4.084,27.871,27.871,0,0,0-5.682,5.99,27.488,27.488,0,0,0-3.786,7.838,37.193,37.193,0,0,0-1.518,9.525,38.645,38.645,0,0,0,.61,9.443,24.637,24.637,0,0,0,2.828,7.641,29.5,29.5,0,0,0,9.5,10.245,104.82,104.82,0,0,0,13.918,7.219,60.194,60.194,0,0,1,10.145,5.323,6.532,6.532,0,0,1,3.043,5.848,4.726,4.726,0,0,1-1.676,3.773,5.937,5.937,0,0,1-3.771,1.19,5.325,5.325,0,0,1-4.588-2.237q-1.571-2.214-1.7-6.618l-30.081-.449a47.82,47.82,0,0,0,.774,8,35.357,35.357,0,0,0,2.032,6.968,28.751,28.751,0,0,0,3.286,5.925A27.236,27.236,0,0,0,887.932-545.458Z",
    transform: "translate(-582.463 667.168)",
    fill: "#ffe42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14304",
    "data-name": "Path 14304",
    d: "M980.8-576.3l22.256.478-1.9,36.285,22.324-.341,5.06-91.609-22.471-1.8-1.783,34.018-22.295-1.011,1.727-34.793-24.637-1.975-4.575,98.217,24.455-.373Z",
    transform: "translate(-582.363 667.182)",
    fill: "#ffe42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14305",
    "data-name": "Path 14305",
    d: "M582.874-369.545,673.1-381.436l.34-29.741L626.97-406.1l.1-17.49,41.144-3.967.306-28.507-41.289,3.09.085-15.394,46.814-2.977.348-30.431-91.618,3.71Z",
    transform: "translate(-582.843 667.545)",
    fill: "#ffe42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14306",
    "data-name": "Path 14306",
    d: "M744.131-425.924l-22.547-77.753-41.094,1.662L719.9-387.609l46.018-6.065,38.732-113.357-35.811,1.443Z",
    transform: "translate(-582.717 667.531)",
    fill: "#ffe42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14307",
    "data-name": "Path 14307",
    d: "M808.7-399.325l64.218-8.464.934-25.293-33.2,3.627.484-14.784,29.359-2.831.881-24.185-29.428,2.206.425-12.988,33.363-2.123.952-25.789L811.8-507.322Z",
    transform: "translate(-582.551 667.523)",
    fill: "#ffe42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14308",
    "data-name": "Path 14308",
    d: "M944.791-508.52q-6.837-3.9-16.9-3.492L887.4-510.375,883.52-409.19l27.324-3.6,1.467-35.126.12-.012,14.262,33.048,27.694-3.647-15.656-34.309a31.958,31.958,0,0,0,7.619-4.985,30.271,30.271,0,0,0,5.726-6.863,34.752,34.752,0,0,0,3.677-8.194,37.535,37.535,0,0,0,1.524-9.084,34.281,34.281,0,0,0-2.651-15.767A22.883,22.883,0,0,0,944.791-508.52ZM931.57-478.226q-.18,4.255-2.145,6.4a8.33,8.33,0,0,1-5.735,2.449l-10.514.844.7-16.792L924.407-486q3.668-.229,5.5,1.847A8.113,8.113,0,0,1,931.57-478.226Z",
    transform: "translate(-582.455 667.517)",
    fill: "#ffe42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14309",
    "data-name": "Path 14309",
    d: "M1011.609-515.388l-13.168,32.963-10.03-32.026-27.421,1.109,24.141,63.219-1.414,27.729,22.644-2.984,1.46-27.112,28.229-63.887Z",
    transform: "translate(-582.355 667.506)",
    fill: "#ffe42d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/Title.286ffad5e26967be5a749300a6a90a29.svg";
export { ForwardRef as ReactComponent };